
define('modules/application/wizard/steps/zoneStep/thermoZoneStep/zoneModel',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",
  "../zoneModel",
  "./zoneCollection"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneModel,
  ZoneCollection) {

  var thermoZoneModel = ZoneModel.extend({
    addConstructors   : function() {
      ZoneModel.prototype.addConstructors.apply(this);
      this.ZoneCollection = ZoneCollection;
    },

    initialize        : function() {
      ZoneModel.prototype.initialize.apply(this);

      this.unbind("change:solenoidValvesModel", this.solenoidValvesModelChangedEventHandler);
      this.bind("change:solenoidValvesModel",   this.solenoidValvesModelChangedEventHandler, this);

      this.unbind("change:probesModel",         this.probesModelChangedEventHandler);
      this.bind("change:probesModel",           this.probesModelChangedEventHandler, this);

      this.unbind("change:ecoModeModel",        this.ecoModeModelChangedEventHandler);
      this.bind("change:ecoModeModel",          this.ecoModeModelChangedEventHandler, this);
    },

    solenoidValvesModelChangedEventHandler : function()  {
      this.get("solenoidValvesModel").unbind("solenoidValve:chosen", this.updateZoneValidity);
      this.get("solenoidValvesModel").bind("solenoidValve:chosen",   this.updateZoneValidity, this);

      this.get("solenoidValvesModel").unbind("actuators:incremented", this.updateZoneValidity);
      this.get("solenoidValvesModel").bind("actuators:incremented",   this.updateZoneValidity, this);

      this.get("solenoidValvesModel").unbind("actuators:decremented", this.updateZoneValidity);
      this.get("solenoidValvesModel").bind("actuators:decremented",   this.updateZoneValidity, this);

      this.get("solenoidValvesModel").unbind("solenoidValve:removed", this.updateZoneValidity);
      this.get("solenoidValvesModel").bind("solenoidValve:removed",   this.updateZoneValidity, this);
    },

    probesModelChangedEventHandler     : function()  {
      this.get("probesModel").unbind("probes:changed",                this.updateZoneValidity);
      this.get("probesModel").bind("probes:changed",                  this.updateZoneValidity, this);

      this.get("probesModel").unbind("probes:removed",                this.updateZoneValidity);
      this.get("probesModel").bind("probes:removed",                  this.updateZoneValidity, this);
    },

    ecoModeModelChangedEventHandler    : function()  {
      this.get("ecoModeModel").unbind("ecoMode:changed",              this.updateZoneValidity);
      this.get("ecoModeModel").bind("ecoMode:changed",                this.updateZoneValidity, this);
    },

    areSolenoidValvesValid             : function() {
      var model = this.get("solenoidValvesModel");
      if(model){
        var combinedPlant = model.get("combinedPlant").quantity ? model.get("combinedPlant").quantity : 0;
        var heatingPlant  = model.get("heatingPlant").quantity  ? model.get("heatingPlant").quantity  : 0;
        var breezingPlant = model.get("breezingPlant").quantity ? model.get("breezingPlant").quantity : 0;

        return ((combinedPlant+heatingPlant+breezingPlant)>0);
      }else
        return false;
    },

    areProbesValid                     : function() {
      var isValid;
      if (
          (this.get("probesModel").get("useMainControlUnitAsMasterProbe"))||
          (
            (this.get("probesModel").get("productCode"))&&
            (this.get("probesModel").get("productCode")!=="")
          )
         ) {
        isValid = true;
      }
      else
        isValid = false;

      return isValid;
    },

    areEcoModeValid                    : function()  {
      var isValid;

      if ((this.get("ecoModeModel").get("ecoModeRequired"))&&(this.get("ecoModeModel").get("packageClassId"))&&(this.get("ecoModeModel").get("packageClassId")!==""))
        isValid = true;
      else {
        if (!this.get("ecoModeModel").get("ecoModeRequired"))
          isValid = true;
        else
          isValid = false;
      }

      return isValid;
    },

    updateZoneValidity                 : function()  {
      if (this.areSolenoidValvesValid()&&this.areProbesValid()&&this.areEcoModeValid()) {
        this.set("valid", true);
        this.trigger("zone:valid");
      }
      else {
        this.set("valid", false);
        this.trigger("zone:invalid");
      }
      this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
    },

    fourZonesMainControlUnitChosen     : function()  {
      this.get("probesModel").set("useMainControlUnitAsMasterProbe", true);
      this.get("probesModel").fetchProbes();
      this.get("stepEventAggregator").trigger("render:requested");
    },

    mainControlUnitChosen              : function()  {
      this.get("probesModel").set("useMainControlUnitAsMasterProbe", false);
      this.get("probesModel").fetchProbes();
      this.get("stepEventAggregator").trigger("render:requested");
    },

    gotOneClimavenetaProductAtLeast    : function()  {
      return (
        (this.get("solenoidValvesModel").get("combinedPlant").type=="2054") ||
        (this.get("solenoidValvesModel").get("heatingPlant").type =="2054") ||
        (this.get("solenoidValvesModel").get("breezingPlant").type=="2054")
      );
    },

    removeClimavenetaProducts          : function()  {
      this.get("solenoidValvesModel").removeClimavenetaProducts();
    },

    gotActivatedEcoFunction            : function()  {
      return this.get("ecoModeModel").get("ecoModeRequired") ? true : false;
    },

    disableEcoFunction                 : function()  {
      this.get("ecoModeModel").inhibitEcoMode();
    },

    mainControlUnitChosenEventHandler   : function(e) {
      if (this.collection.at(0).get("probesModel").attributes) {
        if (BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber")==4)
          this.collection.at(0).fourZonesMainControlUnitChosen();
        else
          this.collection.at(0).mainControlUnitChosen();
      }
    },

    mainControlUnitSelectedEventHandler : function(model, event, maxZoneNumber) {
      var toReturn        = true;
      var mustRemoveZones = false;

      //If I am passing from a 99zones central to 4zones one
      if (this.collection.length>maxZoneNumber) {

        //If there are more than maxZoneNumber zones
        if (confirm($.i18n._("IDS_W1_9092", [(maxZoneNumber+1), this.collection.length])))
          mustRemoveZones = true;
        else
          toReturn = false;
      }


      //If the new MCU is a 4zones one
      if ((toReturn)&&(maxZoneNumber==4)) {

        //If there's one Climaveneta product at least
        if (this.collection.thereIsOneClimavenetaProductAtLeast()) {
          if (confirm($.i18n._("IDS_W1_9080"))) {

            //If there's one eco function activated at least
            if (this.collection.thereIsOneEcoFunctionActivatedAtLeast()) {
              if (confirm($.i18n._("IDS_W1_9081"))) {

                this.collection.disableAllEcoFunctions();
                this.collection.removeClimavenetaProducts();

              }
              else
                toReturn = false;
            }
            else {
              this.collection.removeClimavenetaProducts();
            }
          }
          else
            toReturn = false;
        }
        else {
          if (this.collection.thereIsOneEcoFunctionActivatedAtLeast()) {
            if (confirm($.i18n._("IDS_W1_9081"))) {
              this.collection.disableAllEcoFunctions();
            }
            else
              toReturn = false;
          }
        }
      }

      //Remove zones in excess
      if (mustRemoveZones)
        for(var i=this.collection.length-1; i>=maxZoneNumber; i--)
          this.removeZone(this.collection.models[i]);

      if (toReturn)
        window.BticinoS4B.eventAggregator.trigger("mainControlUnit:changeApproved", event);
      else
        window.BticinoS4B.eventAggregator.trigger("mainControlUnit:changeNotApproved", event);
    }
  });

  // Required, return the module for AMD compliance
  return thermoZoneModel;
});